
<div class="site-panel w-100">
    <v-row class="no-frame">
        <v-col class="main-first-col modal-tab">
            <v-row class="no-frame">
                <v-col class="no-frame col-6 pr-2">
                    <f-enum-select
                        v-model       = "type"
                        :label        = "$t('unit.type.label')"
                        module        = "msd"
                        type          = "siteType"
                        :hide-details = "true"
                        :readonly     = "readonly"
                        class         = "mb-2"
                        @input        = "onTypeChanged"
                    />
                </v-col>
            </v-row>

            <div class="missing-data">
                {{ $t('unit.type.noSpecification') }}
            </div>
        </v-col>
    </v-row>
</div>
